import { useMemo } from "react";

import { matchPartPricing } from "../../../../../util/matchPartPricing";
import { useTireResults } from "../../useTireResults";
import { useTirePricing } from "./useTirePricing";

export const dealerTirePriceFilters: [number, number][] = [
  [0, 100],
  [100, 200],
  [200, 300],
  [300, 400],
  [400, 500],
  [500, 600],
  [600, Infinity],
];

export const useTirePriceOptions = (): Option[] => {
  const [pricing] = useTirePricing();
  const { data: info } = useTireResults({
    keepPreviousData: true,
  });
  const options = useMemo(
    () =>
      dealerTirePriceFilters
        .map<Option>((range, value) => {
          const checked = pricing.includes(value);
          const count =
            info?.allParts.filter(({ partPricing }) =>
              matchPartPricing(partPricing, range)
            ).length || 0;
          return {
            checked,
            count,
            range,
            value,
          };
        })
        .filter(({ count }) => count > 0),
    [info?.allParts, pricing]
  );

  return options;
};

type Option = {
  checked: boolean;
  count: number;
  range: [number, number];
  value: number;
};
